import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  houses: [],
};

export const createHouse = createAsyncThunk(
  "createHouse/house",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("houses", data);
      enqueueSnackbar("House is added successfully");
      navigate(PATH_DASHBOARD.entries.houses.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchHouse = createAsyncThunk(
  "fetchHouse/house",
  async ({ enqueueSnackbar, school_id, limit = 1000, page = 0 }, thunkApi) => {
    try {
      let response;
      if (school_id) {
        response = await axiosInstance.get(
          `houses?school_id=${school_id}&limit=${limit}&page=${page + 1}`
        );
      } else {
        response = await axiosInstance.get(
          `houses?limit=${limit}&page=${page + 1}`
        );
      }

      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateHouse = createAsyncThunk(
  "updateHouse/house",
  async ({ slug, data, enqueueSnackbar, setOpenEdit }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`houses/${slug}`, data);
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        slug,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteHouse = createAsyncThunk(
  "deleteHouse/house",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`houses/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const houseSlice = createSlice({
  name: "house",
  initialState,
  extraReducers: (builder) => {
    // TODO: create house
    builder.addCase(createHouse.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createHouse.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createHouse.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch house
    builder.addCase(fetchHouse.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchHouse.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.houses = action.payload;
    });

    builder.addCase(fetchHouse.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update house
    builder.addCase(updateHouse.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateHouse.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("House is updated successfully");
      state.houses.data = state.houses.data.map((house) =>
        house.slug === action.payload.slug ? action.payload.data : house
      );
      action.payload.setOpenEdit(false);
    });

    builder.addCase(updateHouse.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete house
    builder.addCase(deleteHouse.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteHouse.fulfilled, (state, action) => {
      state.isLoading = false;
      state.houses.data = state.houses.data.filter(
        (size) => size.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("House is deleted successfully");
    });

    builder.addCase(deleteHouse.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default houseSlice.reducer;
